import { useState } from 'react';
import { InformationFilled, Close } from '@carbon/icons-react';
import { ALERT_TYPES, AlertType } from '@/constants/common.constants';
import './alert-style.scss';

interface AlertLink {
  text: string;
  onClick: () => void;
}

interface AlertProps {
  type?: AlertType;
  text: string | React.ReactNode;
  link?: AlertLink;
  dismissible?: boolean;
  onClose?: () => void;
  className?: string;
}

const Alert = ({
  type = ALERT_TYPES.INFO,
  text,
  link,
  dismissible = false,
  onClose,
  className,
}: AlertProps) => {
  const [visible, setVisible] = useState(true);

  const alertConfig = {
    [ALERT_TYPES.SUCCESS]: {
      backgroundColor: 'var(--success-light-1)',
      color: 'var(--success-dark-1)',
    },
    [ALERT_TYPES.ERROR]: {
      backgroundColor: 'var(--danger-light-1)',
      color: 'var(--danger-dark-1)',
    },
    [ALERT_TYPES.WARNING]: {
      backgroundColor: 'var(--warning-light-1)',
      color: 'var(--warning-dark-1)',
    },
    [ALERT_TYPES.INFO]: {
      backgroundColor: 'var(--info-light-1)',
      color: 'var(--info-dark-1)',
      Icon: InformationFilled,
    },
  };

  const { backgroundColor, color } =
    alertConfig[type] || alertConfig[ALERT_TYPES.INFO];

  const handleClose = () => {
    setVisible(false);
    if (onClose) {
      onClose();
    }
  };

  if (!visible) return null;

  return (
    <div
      className={`alert-container ${className || ''}`}
      style={{
        backgroundColor,
        borderLeft: `4px solid ${color}`,
        ...(className ? {} : { color }),
      }}
    >
      <div className="alert-content">
        <span>
          {typeof text === 'string' ? text : <>{text}</>}
          {link && (
            <span className="alert-link" onClick={link.onClick}>
              {link.text}
            </span>
          )}
        </span>
        {dismissible && (
          <Close
            className="small-icon alert-close-icon"
            onClick={handleClose}
          />
        )}
      </div>
    </div>
  );
};

export { Alert };
